import AppConfig from "./../../services/AppConfig";
import { Component, Vue, Prop } from "vue-property-decorator";
import { Mutations } from "@/store/index.ts";

@Component
export default class UserDiscover extends Vue {
  @Prop({ required: true }) readonly clientAppCode!: string;
  @Prop({ required: true }) readonly resourceAppCode!: string;
  @Prop({ required: false }) readonly environment?: string;
  @Prop({ required: false }) readonly redirectUrl?: string;

  private username = "";
  private signInErrors: Array<string> = [];
  private processing = false;

  public async discover() {
    this.processing = true;

    const requestOptions = {
      headers: {
        Authorization: `Bearer ${this.$route.query.accesstoken}`,
        "Accept-Language": this.$i18n.locale,
      },
    };

    let url = `${AppConfig.masterAuthUrl}api/tenant/discover/user?username=${encodeURIComponent(this.username)}`;
    url += `&clientAppCode=${encodeURIComponent(this.clientAppCode)}`;
    url += `&resourceAppCode=${encodeURIComponent(this.resourceAppCode)}`;
    if(this.redirectUrl)
    {
      url += `&redirectUrl=${encodeURIComponent(this.redirectUrl)}`;
    }

    if(this.environment)
    {
      url += `&environment=${encodeURIComponent(this.environment)}`;
    }

    try {
      const response = await fetch(url, requestOptions);
      const result = await response.json();

      if (result.tenants.length === 0) {
        this.signInErrors.push(this.$t("UserNotFound").toString());
      } else {
        this.$emit("user-discovered", result.tenants);
      }
    } catch (error) {
      this.$store.commit(Mutations.NotifyError, error);
    } finally {
      this.processing = false;
    }
  }
}
